module.exports = __webpack_public_path__ + "static/media/gifTwo.654aa1b5.gif";